import {Flex, Button, Text} from '@chakra-ui/react';
import {useTranslate} from '@eksab/i18n';
import {useLineupStore} from './useLineupStore';
import {shallow} from 'zustand/shallow';
import {useIntl} from 'react-intl';
import {useAppSettingsQuery} from '@eksab/hooks';

export function Formations() {
  const format = useIntl().formatNumber;
  const formatFormation = (formation: Formation) =>
    formation
      .split('-')
      .map((num) => format(+num))
      .join('-');

  const t = useTranslate();
  const [activeFormation, changeFormation] = useLineupStore(
    (state) => [state.formation, state.changeFormation],
    shallow,
  );
  const onFormationClick = (formation: Formation) => () => {
    mixpanel?.track('Formation Selected', {formation});
    changeFormation(formation);
  };
  const formations = useAppSettingsQuery().data?.available_formations;

  return (
    <>
      <Text fontSize="xl" fontWeight="800" mb="5">
        {t('fantasy.lineup.step1')}
      </Text>

      <Flex flexWrap="wrap" gap="2">
        {formations?.map((formation) => (
          <Button
            key={formation}
            variant="secondary"
            fontWeight={activeFormation === formation ? 800 : 500}
            isActive={activeFormation === formation}
            onClick={onFormationClick(formation)}
          >
            {formatFormation(formation)}
          </Button>
        ))}
      </Flex>
    </>
  );
}
